@if (isTeamProject) {
  <div class="team-comments-container">
    @for (comment of comments; track trackCommentById($index, comment)) {
      <div class="team-comment" [class.first-unread]="comment.id === firstUnreadCommentId">
        <div class="header">
          <div class="author">{{ getAuthorDisplayNameForComment(comment) }}</div>
          <div class="timestamp">{{ comment.createdAt | date: 'dd.MM.yyyy H:mm' }}</div>
        </div>
        <div>
          {{ comment.content }}
        </div>
        @if (canDeleteComment(comment)) {
          <button mat-icon-button (click)="deleteComment(comment.id)" class="delete-button" color="accent">
            <mat-icon>delete</mat-icon>
          </button>
        }
      </div>
    }
  </div>
}
<div class="add-comment-container">
  <form class="dt-form" (ngSubmit)="addComment(teamCommentInput)">
    <mat-form-field subscriptSizing="dynamic">
      <mat-label i18n>Kommentar hinzufügen</mat-label>
      <input matInput #teamCommentInput />
      <button mat-icon-button matSuffix color="accent" [disabled]="!teamCommentInput.value"><mat-icon>send</mat-icon></button>
    </mat-form-field>
  </form>
</div>
